import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  dialogStop: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "32px"
  },
  dialogStopContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
    alignSelf: "stretch"
  },
  dialogStopIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "55px",
    height: "55px",
    borderRadius: "78px",
    backgroundColor: theme.palette.error.error100,
    "& img": {
      width: "60%"
    }
  },
  dialogTitle: {
    fontSize: "20px",
    fontWeight: "600",
    maxWidth: '60%',
    textAlign: 'center'
  },
  dialogDescription: {
    color: theme.palette.grey.grey500,
    fontWeight: "400",
    fontSize: "14px"
  }
}));

export default useStyles;